import React from 'react'

const Navbar = ({ isAuthenticated, onLogoutClick, name }) => {
  const navbar = isAuthenticated ?
    <div className="br-header">
      <div className="br-header-left">
        <div className="navicon-left hidden-md-down">
          <a titile="Menu" id="btnLeftMenu"><i className="icon ion-navicon-round"></i></a>
        </div>
        <div className="navicon-left hidden-lg-up">
          <a titile="Menu" id="btnLeftMenuMobile"><i className="icon ion-navicon-round"/></a>
        </div>
      </div>
      <div className="br-header-right">
        <nav className="nav">
          <div className="dropdown">
            <div className="nav-link nav-link-profile">
              <span className="logged-name hidden-md-down tx-white mg-t-15">Hi, {name}</span>
            </div>
          </div>
          <div className="navicon-right">
            <a title="Logout" className="pos-relative" onClick={onLogoutClick}><i className="icon ion-log-out tx-20 tx-white"/></a>
          </div>
        </nav>
      </div>
    </div> : undefined
  return (
    <div>
      {navbar}
    </div>
  )
}

export default Navbar


// WEBPACK FOOTER //
// ./src/components/Navbar.js